import { GetNavigationTreeData, NavigationTree } from '@/entities/app/types';
import { api } from '@/services';

export const getNavigationTree = async (params: GetNavigationTreeData): Promise<NavigationTree> =>
  api.get('/nested-structure', { params });
